module.exports = __webpack_public_path__ + "static/img/yy13.2d4657a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/rongyu/yy13.jpg
// module id = ntPk
// module chunks = 1